module.exports = __webpack_public_path__ + "static/media/camillos-daughter.8c50e0e8.jpeg";